<!-- 教师每周日活趋势图 -->
<template>
  <div  class="teacher-week-chart">
    <!-- <div class="teacher-week-chart-line"></div> -->
    <div class="teacher-week-chart-title">
      <div class="name">教师每周日活趋势图</div>
      <div class="week">
        <i class="el-icon-arrow-left" @click="reduceWeek"></i>
        {{ weeks }}周
        <i class="el-icon-arrow-right" @click="addWeek"></i>
      </div>
    </div>
    <!-- <e-charts ref="screenUseRef"  class="chart" :option="screenUseOptions" autoresize theme="light"></e-charts> -->
    <!-- v-show="!isShow" -->
    <div class="chart" id="teacherWeekChartId" ></div>
    <div class="chart-error" v-show="isShow">
        <div class="detail">
            <span class="detail">暂无数据</span>
        </div>
    </div>
  </div>
</template>

<script>
import {getPlatformVisitDayStatAPI,getPlatformVisitStatAPI,getSchoolDfStatAPI,getAtSchoolDataAPI} from "@/service/api.js"
export default {
  name: 'teacher-week-chart',
  components: {
  },
  props:{
    //区域id
    regionId:{
      type:String,
      default:''
    },
    regionType:{
      type:String,
      default:''
    },
    //省id
    provinceId:{
      type:String,
      default:''
    },
    //市id
    cityId:{
      type:String,
      default:''
    },
    //区id
    districtId:{
      type:String,
      default:''
    },
    //乡镇地址
    address:{
      type:String,
      default:''
    },
    //学校id
    schoolId:{
      type:String,
      default:''
    }
  },
  watch:{
    address(){
      if(this.schoolId){
        this.getAtSchoolData();
      }else{
        this.getSchoolDfStat();
      }
    },
    schoolId(){
      if(this.schoolId){
        this.getAtSchoolData();
      }else{
        this.getSchoolDfStat();
      }
    }
  },
  data() {
      return {
        //默认不展示缺醒图
        isShow:false,
        //当前周在当前学年是第几周
        weeks:"",
        //学年开始时间
        yearStartTime:"",
        dateList:[],
        //学年结束时间
        yearEndTime:"",
        dateParams:{
          start:"",
          end:""
        },
        weekList:[],
        teacherNum:0
      }
  },
  methods: {
    /**
     * @name 获取省市区下学校的教师
     */
     getSchoolDfStat(){
      let params = {
        districtId:this.districtId,
        regionId:this.regionId,
        province:this.provinceId,
        city:this.cityId,
        address:this.address
      }
      getSchoolDfStatAPI(params).then((res)=>{
        this.teacherNum = res.teaCount;
        //获取平台访问按天统计数据
        this.getPlatformVisitDayStat();
      })
    },
    /**
     * @name 获取学校下教师数
     */
    getAtSchoolData(){
      let params = {
        schoolId:this.schoolId,
        startTime:this.dateParams.start ? `${this.dateParams.start} 00:00:00` : '',
        endTime:this.dateParams.end ? `${this.dateParams.end} 23:59:59` : '',
      }
      getAtSchoolDataAPI(params).then((res)=>{
        this.teacherNum = res.teaNum
        //获取平台访问按天统计数据
        this.getPlatformVisitDayStat();
      })
    },
    /**
     * @name 减少周数
     */
    reduceWeek(){
      if(this.weeks == 1){
        return 
      }
      this.weeks--;
      this.dateParams = this.$utils.getWeekStartAndEnd(this.yearStartTime,this.yearEndTime,this.weeks);
      this.weekList = this.$utils.getDayArray(this.dateParams.start,this.dateParams.end);
      //获取平台访问按天统计数据
      this.getPlatformVisitDayStat();
    },
    /**
     * @name 增加周数
     */
    addWeek(){
      this.weeks++;
      this.dateParams = this.$utils.getWeekStartAndEnd(this.yearStartTime,this.yearEndTime,this.weeks);
      this.weekList = this.$utils.getDayArray(this.dateParams.start,this.dateParams.end);
      //获取平台访问按天统计数据
      this.getPlatformVisitDayStat();
    },
    /**
     * @name 初始化图标
     */
    initEchart(){
      let _this=this;
      let date = [];
      let data = [];
      this.dateList.forEach((item)=>{
        date.push(item.statsDate.substring(item.statsDate.length - 5))
        data.push(item.progress)
      })
      let dataSource = _this.$echarts.init(
          document.getElementById('teacherWeekChartId')
      );
      const option = {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            var relVal =
              params.length > 1
                ? params[0].name +
                  "</br>" +
                  params[0].marker +
                  Math.round(params[0].value * 100) / 100 +
                  "%" +
                  "</br>" +
                  params[1].marker +
                  Math.round(params[1].value * 100) / 100 +
                  "%"
                : params[0].name +
                  "</br>" +
                  params[0].marker +
                  Math.round(params[0].value * 100) / 100 +
                  "%";
            return relVal;
          },
        },
        grid: {
          left: "20px",
          right: "60px",
          bottom: "0",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data:date,
          boundaryGap: false,
          name:"时间",
          axisLabel: {
            interval: "auto",
            textStyle: {
              color: "#999",
              fontSize: "16px",
            },
          },
          axisTick: {
            alignWithLabel: false,
            interval: "auto",
            show: true,
            inside: false,
            length: 5,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#D6D6D6",
            },
          },
        },
        yAxis: {
          type: "value",
          name:"活跃指数（%）",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#D6D6D6",
            },
          },
          axisLabel: {
            show: true,
            verticalAlign: "middle",
            textStyle: {
              color: "#999",
              fontSize: "16px",
            },
            formatter: "{value}%",
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            // data: ['20','40','60','80','70','50','30'],
            data:data,
            // name: "授课应用率",
            type: "line",
            itemStyle: {
              normal: {
                color: "#3C71DC",
                lineStyle: {
                  color: "#3C71DC",
                  width: 3, //折线宽度
                },
              },
            },
            smooth: true
          }
        ],
      };
      dataSource.setOption(option);
      window.addEventListener("resize", function () {
          dataSource.resize();
      });
    },
    /**
     * @name 获取当前学年的开始时间结束时间
     */
    getYearTime(){
      // if(){}
      //判断当前日期是在学年的前半段还是后半段
      let year = new Date().getFullYear();
      //当前时间大于学年开始时间，则处于学年的后半段
      if(new Date().getTime() < new Date(`${year}-08-10 00:00:00`).getTime()){
        this.yearStartTime = `${year-1}-08-10`;
        this.yearEndTime = `${year}-08-09`;
      }else{
        this.yearStartTime = `${year}-08-10`;
        this.yearEndTime = `${year+1}-08-09`;
      }
      let startDate = new Date(this.yearStartTime);
      let currentDate = new Date();
      // 计算当前日期和学年开始日期相差的天数
      let daysDiff = Math.floor((currentDate - startDate) / (1000 * 60 * 60 * 24)) + 1 - 7 + startDate.getDay();
      // 计算当前日期所在周数
      let currentWeek = Math.ceil(daysDiff / 7) + 1;
      this.weeks = currentWeek;
      this.dateParams = this.$utils.getWeekStartAndEnd(this.yearStartTime,this.yearEndTime,this.weeks);
      this.weekList = this.$utils.getDayArray(this.dateParams.start,this.dateParams.end);
      console.log(this.weekList);
      if(this.schoolId){
        //获取学校下教师数
        this.getAtSchoolData();
      }else{
        //获取省市区下学校的教师数
        this.getSchoolDfStat();
      }
    },
    /**
     * @name 获取平台访问按天统计数据
     */
    getPlatformVisitDayStat(){
      let params = {
        regionId:this.regionId,
        provinceId:this.provinceId,
        cityId:this.cityId,
        districtId:this.districtId,
        address:this.address,
        schoolId:this.schoolId,
        startTime:this.dateParams.start ? `${this.dateParams.start} 00:00:00` : '',
        endTime:this.dateParams.end ? `${this.dateParams.end} 23:59:59` : '',
        regionType:this.regionType
      }
      getPlatformVisitDayStatAPI(params).then((res)=>{
        this.dateList = [];
        this.weekList.forEach((item)=>{
          let index = res.findIndex((value)=>{
            return item == value.statsDate
          })
          if(index != -1){
            this.dateList.push({
              ...res[index],
              progress:Number((res[index].visitTeaNum/this.teacherNum*100).toFixed(2)) || 0
            })
          }else{
            this.dateList.push({
              progress:0,
              statsDate: item,
              visitStuNum:0,
              visitTeaNum:0
            })
          }
        })
        this.initEchart();
      }).catch((err)=>{})
    },
  },
  mounted() {
    //获取当前学年的开始时间结束时间
    this.getYearTime();
  }
}
</script>

<style lang="scss" scoped>
.teacher-week-chart{
  width: 100%;
  height: 260px;
  .teacher-week-chart-line{
    width: 100%;
    height: 2px;
    background: linear-gradient(to right, #209CFF, transparent);
    background-color: rgba(0, 0, 0, 0);
    margin-bottom: 4px;
  }
  .teacher-week-chart-title{
    background: url("~@/assets/images/qxdataboard/head-bg.png") no-repeat ;
    background-size:100% 100%;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 13px 0 18px;
    .name{
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
    .week{
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #B9E3F7;
      display: flex;
      align-items: center;
      i{
        cursor: pointer;
      }
    }
  }
  .chart{
    width: 100%;
    height: 200px;
  }
  .chart-error{
    width: 100%;
    height: 200px;
  }
}
</style>